<template>
  <div class="flex items-center justify-end relative w-[429px]">
    <SearchInput />
    <div v-if="$store.state.user.token" class="flex items-center outLeftControl">
      <msg-box />
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper flex items-center">
          <div class="flex items-center space-x-1 pr-[5px]">
            <img class="user-avatar shadow-sm border border-solid border-gray-300 rounded-full mr-[10px]" :src="avatar" />
            <div class="text-[16px] text-[#1D1D1D]">{{ name }}</div>
          </div>
          <svg-icon icon-class="subscript" width="11px" height="7px" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <div class="px-[30px] flex pt-[17px] mb-[20px] min-w-[248px]">
            <img class="w-[60px] h-[60px] rounded-[50%] mr-[10px]" :src="avatar" alt="" />
            <div class="flex-1">
              <p class="text-[18px] text-[#1D1D1D]">{{ name }}</p>
              <div class="flex items-center mb-[5px]">
                <img v-if="userInfo?.credit_level" class="w-[36px] h-[18px] mr-[6px]" :src="userInfo?.credit_level?.icon ?? ''" alt="" />
                <!-- <img v-if="userInfo?.honor" class="w-[75px] h-[23px]" :src="userInfo?.honor?.icon ?? ''" alt="" :title="userInfo?.honor?.name ?? ''" /> -->
                <img v-if="userInfo?.honor?.icon" class="max-w-[78px] max-h-[29px] object-cover rounded-[unset]" :src="userInfo?.honor?.icon ?? ''"
                  :title="userInfo?.honor?.name ?? ''" alt="" />
              </div>
              <!-- <div> 
                <div class="bg-[#f7f7f7] w-[118px] rounded-[5px]"><div id="g-progress" class="g-progress" :style="`--progress: ${ radio }%`">{{progress}}</div></div>
              </div> -->
              <div class="w-[100%]">
                <el-progress :text-inside="true" :stroke-width="15" :percentage="+radio" :color="'#e1f1f3'" :define-back-color="'#f7f7f7'" :text-color="'#1CBDCB'" :format="format" />
              </div>
            </div>
          </div>
          <el-dropdown-item @click.native="goToDevelopPlat"><div class="dropItem"><svg-icon class="mr-[5px]" width="15px" height="15px" icon-class="platform" />前往控制台</div></el-dropdown-item>
          <el-dropdown-item @click.native="routePush(1)"><div class="dropItem"><svg-icon class="mr-[5px]" width="15px" height="15px" icon-class="user" />个人中心</div></el-dropdown-item>
          <el-dropdown-item v-if="hasAdminPrivilege" @click.native="routePush(0)"><div class="dropItem"><svg-icon class="mr-[5px]" :width="'13px'" :height="'17px'" icon-class="dev" />社区管理后台</div></el-dropdown-item>
          <!-- <el-dropdown-item @click.native="goToDevelopPlat"><i class=" pr-1"></i>开发者平台</el-dropdown-item> -->
          <el-dropdown-item @click.native="logout">
            <div class="dropItem"><svg-icon class="mr-[5px]" width="15px" height="15px" color="#1cbdcb" icon-class="shutdown" />退出登录</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-else class=" outLeftControl">
      <a :href="`/#/oauth?app_id=5012568a421eeb0b&redirect_url=${urlOrigin}`"
         class="flex items-center px-[23px] h-[32px] box-border text-[18px] text-[#fff] font-semibold cursor-pointer rounded-[3px] bg-gradient-to-r from-[#23E7F7] to-[#71B2F1] hover:text-[#fff]">
        登录
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MsgBox from '@/components/MsgBox.vue'
import SearchInput from '@/components/searchInput.vue'
import { getUserDetail } from '@/api/user'
import { getToken } from '@/utils/auth' // get token from cookie
import { isProd, getDevMainpage } from '@/utils/common'
export default {
  name: 'HeaderInfoControl',
  components: {
    MsgBox,
    SearchInput,
  },
  computed: {
    ...mapGetters(['avatar', 'name', 'auth', 'uid', 'username']),
    hasAdminPrivilege() {
      return JSON.parse(localStorage.getItem('userInfo') ?? '{}')?.hasAdminPrivilege
    }
  },
  data() {
    return {
      urlOrigin: encodeURIComponent(window.location.href),
      userInfo: {},
      progress: '',
      radio: '',
    }
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    routePush(type) {
      // 1 个人中心; 0 社区管理后台
      if (type) {
        this.$router.push({
          path: `/forum/personalCenter`,
          query: { uid: this.userInfo?.uid }
        })
      } else {
        location.href = '/adminfront/'
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      // this.$store.state.user.token = getToken()
      // this.$store.state.app.render = !this.$store.state.app.render
      window.location.href = `/#/oauth?app_id=5012568a421eeb0b&redirect_url=${location.origin}/#${this.$router.currentRoute.fullPath}`
    },
    goToDevelopPlat() {
      let devUrl = '//dev.minicreate.qq.com/'
      if (isProd()) {
        devUrl = `//${getDevMainpage()}/`
      }
      window.open(devUrl)
    },

    getInfo() {
      if(!getToken()) return
      getUserDetail().then((res) => {
        if (res?.code === 200) {
          this.userInfo = res?.data ?? {}

          if (res?.data?.credit) {
            const { current, max, min } = res?.data?.credit ?? {}
            this.progress = `${current}/${max}`

            let radio
            if (current >= max) {
              radio = 1
            } else {
              radio = (current - min) / (max - min)
            }
            // console.log('radio1231321', radio)
            this.radio = Math.floor(radio * 100)
          }
        }
      })
    },

    format(percentage) {
        return this.progress;
    }

  },
}
</script>

<style lang="scss" scoped>
.avatar-container {
  margin-right: 10px;
  top: -2px;

  .avatar-wrapper {
    margin-top: 5px;
    position: relative;
    height: 40px;

    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
    }

    .el-icon-caret-bottom {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 14px;
      background: #fff;
      border-radius: 2px;
      font-size: 12px;
    }
  }
}
.g-progress {
  margin: auto;
  width: 100%;
  height: 12px;
  border-radius: 5px;
  background: rgba(28, 189, 203, 0.10);
  // border: 1px solid #ccc;
  transition: 0.3s --progress;
  /* display: none; */
  text-align: right;
  font-size: 8px;
  color: var(--, #1CBDCB);
}

::v-deep .el-progress-bar__innerText{
  font-size: 12px;
  color: #1CBDCB;
  position: absolute;
  width: 110px;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-progress-bar__inner{
  display: flex;
  justify-content: end;
  align-items: center;
}
.el-dropdown-menu--medium .el-dropdown-menu__item{
  line-height: unset;
}
.el-dropdown-menu--medium .el-dropdown-menu__item:hover{
  background-color: #f8f9fa;
}
.el-dropdown-menu--medium .el-dropdown-menu__item:hover svg{
  fill:#1CBDCB
}
.dropItem{
  display: flex;
  align-items: center;
  padding: 10px 13px;

  color: #646464;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.el-dropdown-menu--medium .el-dropdown-menu__item:hover>.dropItem{
  color: #1CBDCB;
}

</style>